/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import { connect } from "react-redux";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import classes from "./activate.module.css";

import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "../../../component/tabPanel";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import Input from "../../../component/inputpm";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import SaveIcon from "@mui/icons-material/Save";
import Tooltip from "@mui/material/Tooltip";
import SyncIcon from "@mui/icons-material/Sync";
import CloudDownload from "@mui/icons-material/CloudDownload";
import { Checkbox } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";

const ActivationTable = (props) => {
  const { t } = props;
  const [tab, setTab] = useState(0);
  const tabChange = (event, newvalue) => {
    setTab(newvalue);
  };
  const setInputType = (val) => {
    if (val === "string") {
      return "text";
    } else if (val === "number" || val === "decimal") {
      return "number";
    } else if (val === "email") {
      return "email";
    } else if (val === "date") {
      return "date";
    } else if (val === "datetime") {
      return "datetime-local";
    } else {
      return "text";
    }
  };
  return (
    <>
      <AppBar position="static" color="transparent">
        <Tabs value={tab} onChange={tabChange} className={classes.tabClass}>
          {props.data.map((product, i) => (
            <Tab key={i} label={product.productName} />
          ))}
        </Tabs>
        <Tooltip title={t("REFRESH")}>
          <IconButton
            onClick={props.reloadActivationData}
            style={{ position: "absolute", marginTop: "-45px", right: "35px" }}
          >
            <SyncIcon />
          </IconButton>
        </Tooltip>
      </AppBar>
      {props.data.map((product, i) => (
        <TabPanel
          value={tab}
          index={i}
          key={i}
          style={{ width: "100%" }}
          className={classes.tabPanelClass}
        >
          <Paper className="tablePaper">
            <TableContainer>
              <Table
                className={classes.table + " " + classes.activateDynamicTable}
              >
                <TableHead>
                  <TableRow>
                    {/* <TableCell>{t('S_NO')}</TableCell> */}
                    <TableCell>{t("SOLUTION_NO")}</TableCell>
                    {product.activationParams[0].parameters.map((param, j) => (
                      <TableCell key={j}>{param.label}</TableCell>
                    ))}
                    <TableCell>{t("STATUS")}</TableCell>
                    <TableCell align="center">{t("ACTION")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {product.activationParams.map((param, j) => (
                    <React.Fragment key={j}>
                      {props.isEdittable && param.status === "AVAILABLE" ? (
                        <TableRow>
                          {/* <TableCell>{j + 1}</TableCell> */}
                          <TableCell
                            align="left"
                            className={classes.statusTextColumn}
                          >
                            {param.packageIndex}
                          </TableCell>
                          {param.parameters.map((input, k) =>
                            input.type === "boolean" ? (
                              <TableCell align="left" key={k}>
                                <Checkbox
                                  checked={input.value}
                                  onChange={(e) =>
                                    props.onChange(props.componentType, i, j, e)
                                  }
                                  color="primary"
                                  name={input.name}
                                />
                              </TableCell>
                            ) : (
                              <TableCell align="left" key={k}>
                                <Input
                                  name={input.name}
                                  value={input.value}
                                  type={setInputType(input.type)}
                                  onBlur={(e) =>
                                    props.validateInput(
                                      props.componentType,
                                      i,
                                      j,
                                      e,
                                    )
                                  }
                                  onChange={(e) =>
                                    props.onChange(props.componentType, i, j, e)
                                  }
                                  autoComplete="on"
                                  inputProps={{
                                    error: input.isInvalid,
                                    helperText:
                                      input.isInvalid &&
                                      t("INVALID_VALUE_ENTERED"),
                                  }}
                                />
                                {input.validation ? (
                                  <>
                                    <br />
                                    <span style={{ fontSize: "0.75rem" }}>
                                      {/* {t('REGEX_VALIDATION')}:  */}
                                      <b>{input.validation}</b>
                                    </span>
                                  </>
                                ) : (
                                  <span>&nbsp;</span>
                                )}
                              </TableCell>
                            ),
                          )}
                          <TableCell
                            align="left"
                            className={classes.statusTextColumn}
                          >
                            {param.displayStatus}
                          </TableCell>
                          <TableCell
                            align="center"
                            className={classes.statusTextColumn}
                          ></TableCell>
                        </TableRow>
                      ) : (
                        <TableRow>
                          {/* <TableCell>{j + 1}</TableCell> */}
                          <TableCell
                            align="left"
                            className={classes.statusTextColumn}
                          >
                            {param.packageIndex}
                          </TableCell>
                          {param.parameters.map((input, k) => (
                            <TableCell align="left" key={k}>
                              {param.edit ? (
                                <>
                                  <Input
                                    name={input.name}
                                    value={input.value}
                                    type={setInputType(input.type)}
                                    onBlur={(e) =>
                                      props.validateInput(
                                        props.componentType,
                                        i,
                                        j,
                                        e,
                                      )
                                    }
                                    onChange={(e) =>
                                      props.onChange(
                                        props.componentType,
                                        i,
                                        j,
                                        e,
                                      )
                                    }
                                    autoComplete="on"
                                    inputProps={{
                                      error: input.isInvalid,
                                      helperText:
                                        input.isInvalid &&
                                        t("INVALID_VALUE_ENTERED"),
                                    }}
                                  />
                                  {input.validation ? (
                                    <>
                                      <br />
                                      <span style={{ fontSize: "0.75rem" }}>
                                        {/* {t('REGEX_VALIDATION')}:  */}
                                        <b>{input.validation}</b>
                                      </span>
                                    </>
                                  ) : (
                                    <span>&nbsp;</span>
                                  )}
                                </>
                              ) : (
                                <>
                                  {input.type === "datetime"
                                    ? input.value.replace("T", " ")
                                    : input.value}
                                </>
                              )}
                            </TableCell>
                          ))}
                          <TableCell
                            align="left"
                            className={classes.statusTextColumn}
                          >
                            {param.displayStatus}
                          </TableCell>
                          <TableCell
                            align="center"
                            className={classes.statusTextColumn}
                          >
                            {props.isEdittable &&
                              (param.status !== "PROCESSING" ||
                                param.status === "DEATIVATED") &&
                              (param.edit ? (
                                <Tooltip title={t("SAVE")}>
                                  <IconButton
                                    aria-label="Save"
                                    style={{ paddingTop: 0, paddingBottom: 0 }}
                                    onClick={() => {
                                      props.editRow(props.componentType, i, j);
                                    }}
                                  >
                                    <SaveIcon />
                                  </IconButton>
                                </Tooltip>
                              ) : (
                                <Tooltip title={t("EDIT")}>
                                  <IconButton
                                    aria-label="Edit"
                                    style={{ paddingTop: 0, paddingBottom: 0 }}
                                    onClick={() => {
                                      props.editRow(props.componentType, i, j);
                                    }}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                </Tooltip>
                              ))}
                            {param.metadata.length > 0 && (
                              <Tooltip title={t("DOWNLOAD_CREDENTIALS")}>
                                <IconButton
                                  aria-label="Download Credentials"
                                  onClick={() => {
                                    props.downloadCredentials(
                                      param.parameters[0].value,
                                      param.metadata,
                                    );
                                  }}
                                >
                                  <CloudDownload />
                                </IconButton>
                              </Tooltip>
                            )}
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </TabPanel>
      ))}
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(
  withTranslation("translations")(ActivationTable),
);
